// extracted by mini-css-extract-plugin
export default {"holder":"GoogleSignInButton_holder__K6nTb"};